// propertyStatusSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IPropertyStatus,
  IPropertyStatusInitialState,
} from "./propertyStatusModal";
import {
  activeInactivePropertyStatus,
  createPropertyStatus,
  deletePropertyStatus,
  getAllActivePropertyStatuses,
  getAllPropertyStatuses,
  getPropertyStatusByID,
  updatePropertyStatus,
} from "./services/propertyStatus.service";

const initialState: IPropertyStatusInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  PropertyStatusID: null,
  PropertyStatusList: [],
  PropertyStatusDetail: {
    ID: null,
    Title: "",
    IsActive: 1,
  },
};

const propertyStatusSlice = createSlice({
  name: "propertyStatus",
  initialState,
  reducers: {
    clearPropertyStatusDetails: (state) => {
      state.PropertyStatusDetail = initialState.PropertyStatusDetail;
    },
    setPropertyStatusID: (state, action) => {
      state.PropertyStatusID = action.payload;
    },
    clearPropertyStatusID: (state) => {
      state.PropertyStatusID = initialState.PropertyStatusID;
    },
  },
  extraReducers: (builder) => {
    // Get All Property Statuses
    builder.addCase(getAllPropertyStatuses.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllPropertyStatuses.fulfilled,
      (state, action: PayloadAction<IPropertyStatus[]>) => {
        state.loading = false;
        state.PropertyStatusList = action.payload || [];
      },
    );
    builder.addCase(getAllPropertyStatuses.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PropertyStatusList = [];
    });

    // Create Property Status
    builder.addCase(createPropertyStatus.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createPropertyStatus.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createPropertyStatus.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Update Property Status
    builder.addCase(updatePropertyStatus.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updatePropertyStatus.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updatePropertyStatus.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Delete Property Status
    builder.addCase(deletePropertyStatus.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deletePropertyStatus.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deletePropertyStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Get Property Status By ID
    builder.addCase(getPropertyStatusByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getPropertyStatusByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.PropertyStatusDetail = action.payload;
    });
    builder.addCase(getPropertyStatusByID.rejected, (state, action) => {
      state.formLoading = false;
      state.PropertyStatusDetail = initialState.PropertyStatusDetail;
      state.error = action.error.message || "Something went wrong";
    });

    // Get All Active Property Statuses
    builder.addCase(getAllActivePropertyStatuses.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActivePropertyStatuses.fulfilled,
      (state, action: PayloadAction<IPropertyStatus[]>) => {
        state.loading = false;
        state.PropertyStatusList = action.payload || [];
      },
    );
    builder.addCase(getAllActivePropertyStatuses.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PropertyStatusList = [];
    });

    // Active/Inactive Property Status
    builder.addCase(activeInactivePropertyStatus.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(activeInactivePropertyStatus.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(activeInactivePropertyStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearPropertyStatusDetails,
  clearPropertyStatusID,
  setPropertyStatusID,
} = propertyStatusSlice.actions;
export default propertyStatusSlice.reducer;
